import { GraphQLEnumType } from 'graphql'

export type ApplicationOrderField = 'NAME' | 'IMPORTANCE' | 'LANGUAGE'

export const applicationOrderField = new GraphQLEnumType({
  name: 'ApplicationOrderField',
  description: 'Directions to sort a list of items',
  values: {
    NAME: {
      description: 'Order applications by application name'
    },
    IMPORTANCE: {
      description: 'Order applications by importance'
    },
    LANGUAGE: {
      description: 'Order applications by programming language'
    }
  }
})
